import React from 'react'
import Map from '../assets/Map.jpg'
import Portfolio from '../assets/Portfolio.png'
import Snake from '../assets/Snakes.png'
import Audio from '../assets/Audio.png'

const Project = () => {
  return (
    <div name ='projects' className='bg-[#0a192f] w-full md:h-screen text-gray-300'>
        <div className='max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full'>
            <div className='pb-8'>
                <p className='text-4xl font-bold inline border-b-4 text-gray-300 border-pink-600'>Projects</p>
                <p className='py-6'>// Check out some of my recent projects</p>

                {/* container */}
                <div className='grid sm:grid-cols-2 md:grid-cols-2 gap-4'>
                    <div
                    style={{backgroundImage: `url(${Map})`}} 
                    className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Husky Map
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://github.com/tranjas/Husky-Map'>
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>GitHub</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div
                    style={{backgroundImage: `url(${Portfolio})`}} 
                    className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Portfolio Website
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://github.com/tranjas/Portfolio-Website'>
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>GitHub</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div
                    style={{backgroundImage: `url(${Snake})`}} 
                    className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Snake and Apples
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://github.com/tranjas/Snake-and-Apples'>
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>GitHub</button>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div
                    style={{backgroundImage: `url(${Audio})`}}
                    className='shadow-lg shadow-[#040c16] group container rounded-md flex justify-center items-center mx-auto content-div'>
                        {/* Hover Effects */}
                        <div className='opacity-0 group-hover:opacity-100'>
                            <span className='text-2xl font-bold text-white tracking-wider'>
                                Audio Visualizer
                            </span>
                            <div className='pt-8 text-center'>
                                <a href='https://github.com/tranjas/Audio-Visualizer'>
                                    <button className='text-center rounded-lg px-4 py-3 m-2 bg-white text-gray-700 font-bold text-lg'>GitHub</button>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Project